// @flow
import {
  TABLEFLOW_RESOURCES_GRID_FIELDNAMES,
  TABLEFLOW_RESOURCES_GRID_HEADERS,
} from '@streaming-projects/orgs/enums';
import { string } from 'yup';
import { convertConfigArrayToMap } from '@src/configuration/utils';

export const TABLEFLOW_RESOURCE_INPUTS_DETAILS_CONFIG = [
  {
    displayName: TABLEFLOW_RESOURCES_GRID_HEADERS.NAME,
    backendFieldName: TABLEFLOW_RESOURCES_GRID_FIELDNAMES.NAME,
    icon: null,
    validation: string().label(TABLEFLOW_RESOURCES_GRID_HEADERS.NAME).required(),
  },
  {
    displayName: TABLEFLOW_RESOURCES_GRID_HEADERS.CLUSTER_RESOURCE_NAME,
    backendFieldName: TABLEFLOW_RESOURCES_GRID_FIELDNAMES.CLUSTER_RESOURCE_ID,
    displayNameCol: TABLEFLOW_RESOURCES_GRID_FIELDNAMES.CLUSTER_RESOURCE_NAME,
    validation: string()
      .required()
      .label(TABLEFLOW_RESOURCES_GRID_HEADERS.CLUSTER_RESOURCE_NAME)
      .nullable(),
  },
  {
    displayName: TABLEFLOW_RESOURCES_GRID_HEADERS.STORAGE_TYPE,
    backendFieldName: TABLEFLOW_RESOURCES_GRID_FIELDNAMES.STORAGE_TYPE,
    validation: string().required().label(TABLEFLOW_RESOURCES_GRID_HEADERS.STORAGE_TYPE).nullable(),
    displayNameCol: TABLEFLOW_RESOURCES_GRID_FIELDNAMES.STORAGE_TYPE_LABEL,
  },
];

export const TABLEFLOW_RESOURCE_INPUTS_DETAILS_CONFIG_MAP = convertConfigArrayToMap(
  TABLEFLOW_RESOURCE_INPUTS_DETAILS_CONFIG
);
